module.exports = __webpack_public_path__ + "57acb54e89499746de30cf26f9e4c227.png";